import { c as _c } from "react/compiler-runtime";
import { Dialog, Text } from "@flat-ui";
import { INTEGRATION_INFO } from "@src/constants/integrations-constants";

/** Shows dialog for disconnecting an integration */
export function IntegrationsDisconnectDialog(t0) {
  const $ = _c(7);
  const {
    dialogConfirmCallback,
    dialogCancelCallback,
    integrationId
  } = t0;
  const t1 = INTEGRATION_INFO[integrationId];
  let t2;
  if ($[0] !== t1.displayName) {
    t2 = <Text component="p" variant="bodyM">Are you sure you want to disconnect{" "}{t1.displayName}?</Text>;
    $[0] = t1.displayName;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Text component="p" variant="bodyM">This action will remove your personal connection and disable its features in all associated projects.</Text>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== dialogCancelCallback || $[4] !== dialogConfirmCallback || $[5] !== t2) {
    t4 = <Dialog open={true} onConfirm={dialogConfirmCallback} onClose={dialogCancelCallback} confirmText="Disconnect" title="Disconnect account?" variant="danger">{t2}{t3}</Dialog>;
    $[3] = dialogCancelCallback;
    $[4] = dialogConfirmCallback;
    $[5] = t2;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
}